<template>
    <div>
        <div>
            <datetime v-model="globalDate" type="date" class="datetime-theme-black"
                      :max-datetime="(new Date()).toISOString()"
                      ref="date-picker-global"></datetime>
            <div class="summary-container" v-if="isSummaryVisible && isSummaryFetched">
                <threat-summary
                    :summaryStatistics="summaryStatistics"
                    :title="title"
                    :summarySelectedState="summarySelectedState"
                    :isDataTableVisible="isDataTableVisible"
                    :summaryRequestParams="summaryRequestParams"
                    @summaryItemClicked="summaryItemClicked"
                >

                </threat-summary>
            </div>
            <div class="datatable-container">
                <v-client-table v-if="clientPagination && isDataTableVisible" class="client-table" :data="tableData"
                                :columns="columns"
                                :options="options" @loading="loading" @loaded="loaded" ref="clientTable"
                                id="client-table">
                    <!--<span slot="displayBoth" slot-scope="props">{{displayBoth(props)}}</span>-->
                    <img class="details" slot="details" slot-scope="props" @click="onDetailsClick(props.row)"
                         v-show="showOrHideDetail(props.row)" src="ş/magnifying-glass.svg" width="24px"/>
                    <img class="download" slot="download" slot-scope="props" @click="onDownloadClick(props.row)"
                         v-show="showOrHide(props.row)"
                         src="../../assets/cloud-computing.svg" width="24px"/>
                    <div class="button-container grow" slot="editRow" slot-scope="props">
                        <button class="editButton" @click="onEditClick(props.row)">EDIT</button>
                    </div>
                    <div class="button-container grow" slot="deleteRow" slot-scope="props">
                        <button class="delete-button" @click="onDeleteClick(props.row)">DELETE</button>
                    </div>
                    <div class="button-container grow" slot="editDeleteRow" slot-scope="props">
                        <button class="editButton" @click="onEditClick(props.row)">EDIT</button>
                        <button class="delete-button" @click="onDeleteClick(props.row)">DELETE</button>
                    </div>
                    <div class="button-container" slot="editDeleteRow" slot-scope="props">
                        <button class="editButton grow" style="position: relative; margin-right:15px;"
                                @click="onEditClick(props.row)">EDIT
                        </button>
                        <button class="delete-button grow" style="position: relative;"
                                @click="onDeleteClick(props.row)">
                            DELETE
                        </button>
                    </div>
                    <div class="button-container" slot="checkboxRow" slot-scope="props" style="text-align: center">
                        <input type="checkbox" :disabled="canNotified(props.row)" :checked="props.row.checked"
                               @click="onStolenCheckBoxClicked(props.row)"/>
                    </div>
                    <div class="button-container" slot="notify_type" slot-scope="props" style="text-align: center">
                        <div class="circle" :style="{ backgroundColor: props.row.notify_type.color }"></div>
                    </div>

                    <!--<div class="eye-container" slot="eye" slot-scope="props">-->
                    <!--<p class="eye-text" :class="{'eye-text-open': isEyeOpen(props)}">{{getEyeText(props)}}</p>-->
                    <!--<img class="eye-img" @click="onEyeClick(props)"-->
                    <!--src="../../assets/eye-open.svg" width="24px"/>-->
                    <!--</div>-->
                    <p slot="beforeLimit" class="title" v-if="title">{{title}}</p>
                    <div slot="beforeLimit" class="export" v-if="isStolen">
                        <button class="grow send-mail-button" @click="sendMail">
                            Send Mail
                        </button>
                    </div>
                    <div slot="beforeLimit" class="export" v-if="exportable">
                        <select v-model="selectedExportValue" :disabled="!isExportPermitted" :class="setExportClass"
                                @change="exportCsv">
                            <option value="-1" v-show="false" selected>Export</option>
                            <option value="0">CSV</option>
                            <option value="1">JSON</option>
                            <option value="2" v-show="isStixExportAvailable">STIX</option>
                        </select>
                        <!--<button :disabled="!isExportPermitted" :class="setExportClass" @click="exportCsv">-->
                        <!--Export CSV-->
                        <!--</button>-->
                    </div>
                    <!--<div slot="h__eye" slot-scope="props" style="position: relative;">-->
                    <!--<p style="margin: 0">Password</p>-->
                    <!--<img v-if="eyeColumn" id="globalEyeButton" class="global-eye" v-on:click="onGlobalEyeClick"-->
                    <!--src="../../assets/eye-open.svg" width="24px"/>-->
                    <!--</div>-->
                    <input class="isPrimary" slot="isPrimary" slot-scope="props" type=checkbox
                           :checked="props.row.isprimary === 'True' ? 'checked' : ''" disabled=disabled>

                    <div class="ss-thumbnail-container" slot="ssThumbnail" slot-scope="props">
                        <img class="ss-thumbnail" :src="props.row.datatableSS"
                             width="24px" @click="onImageClick(props.row) "/>
                    </div>
                    <img class="email" slot="emailSlot" slot-scope="props" @click="onEmailClick(props.row)"
                         src="../../assets/envelope.svg" width="24px" v-show="showEmail(props.row)"/>

                    <a slot="tooltipCell" slot-scope="props" class="cell-tooltip"
                       @click="onEditClick(getTooltipId(props.row, true))" @mouseover="positionTooltip($event)">
                        {{getTooltipCell(props.row, 'val', false)}}
                        <span class="tooltiptext" v-html="getTooltipCell(props.row, 'tooltip', true)"></span>
                    </a>
                    <span class="url-count" slot="urlCount" slot-scope="props"
                          @click="onUrlCountClick(props.row)">{{props.row.url_count}}</span>
                </v-client-table>

                <!-- ********** SERVER SIDE PAGINATION PAGES ********** -->
                <v-server-table v-if="!clientPagination && isDataTableVisible" class="server-table" :url="url"
                                :columns="columns"
                                :options="options"
                                @loading="loading" @loaded="loaded" id="server-table" ref="serverTable">
                    <div slot="beforeLimit" class="export" v-if="isStolen">
                        <button class="secondary-action-button-big grow send-mail-button" @click="sendMail">
                            Send Mail
                        </button>
                    </div>
                    <div slot="beforeLimit" class="export" v-if="exportable">
                        <select v-model="selectedExportValue" :disabled="!isExportPermitted" :class="setExportClass"
                                @change="exportCsv">
                            <option value="-1" v-show="false" selected>Export</option>
                            <option value="0">CSV</option>
                            <option value="1">JSON</option>
                            <option value="2" v-show="isStixExportAvailable">STIX</option>
                        </select>
                        <!--<button :disabled="!isExportPermitted" :class="setExportClass" @click="exportCsv">-->
                        <!--Export CSV-->
                        <!--</button>-->
                    </div>
                    <div v-if="isNotification" slot="beforeLimit" class="saveChanges">
                        <button class="grow save_changes_button" @click="saveAllChanges(tableData)">
                            Save Changes
                        </button>
                    </div>
                    <!--<span slot="displayBoth" slot-scope="props">{{displayBoth(props)}}</span>-->
                    <img class="details" slot="details" slot-scope="props" @click="onDetailsClick(props.row)"
                         v-show="showOrHideDetail(props.row)" src="../../assets/magnifying-glass.svg" width="24px"/>
                    <img class="download" slot="download" slot-scope="props" @click="onDownloadClick(props.row)"
                         v-show="showOrHide(props.row)"
                         src="../../assets/cloud-computing.svg" width="24px"/>
                    <p slot="beforeLimit" class="title" v-if="title">{{title}}</p>
                    <img class="email" slot="emailSlot" slot-scope="props" @click="onEmailClick(props.row)"
                         src="../../assets/envelope.svg" width="24px" v-show="showEmail(props.row)"/>
                    <div class="ss-thumbnail-container" slot="ssThumbnail" slot-scope="props">
                        <img class="ss-thumbnail" :src="props.row.datatableSS"
                             width="24px" @click="onImageClick(props.row)"/>
                    </div>
                    <span class="url-count" slot="urlCount" slot-scope="props"
                          @click="onUrlCountClick(props.row)">{{props.row.url_count}}</span>
                    <div class="eye-container" slot="eye" slot-scope="props">
                        <p class="eye-text" :class="{'eye-text-open': isEyeOpen(props)}">{{getEyeText(props)}}</p>
                        <img v-if="dontMssp" class="eye-img" @click="onEyeClick(props)"
                             src="../../assets/eye-open.svg" width="24px"/>
                    </div>
                    <!--<div slot="h__eye" slot-scope="props" style="position: relative;">-->
                    <!--<p style="margin: 0">Password</p>-->
                    <!--<img v-if="eyeColumn && dontMssp" id="globalEyeButton" class="global-eye"-->
                    <!--v-on:click="onGlobalEyeClick"-->
                    <!--src="../../assets/eye-open.svg" width="24px"/>-->
                    <!--</div>-->
                    <div class="button-container" slot="checkboxRow" slot-scope="props" style="text-align: center">
                        <input type="checkbox" :disabled="canNotified(props.row)" :checked="props.row.checked"
                               @click="onStolenCheckBoxClicked(props.row)"/>
                    </div>
                    <div class="button-container" slot="type" slot-scope="props"
                         style="text-align: left;">
                        <p v-if="malwareFamilyColumn && showOrHideKnowledgeBasedQuestionMark(props.row)"><a
                            style="cursor: pointer"
                            class="column-text"
                            target="_blank"
                            v-bind:href="getKnowledgeBaseUrl(props.row)">
                            {{props.row.type}}</a></p>
                        <p v-else class="column-text">{{props.row.type}}</p>
                    </div>
                    <div class="button-container" slot="malware_family" slot-scope="props"
                         style="text-align: left;">
                        <p v-if="malwareFamilyColumn && showOrHideKnowledgeBasedQuestionMark(props.row)"><a
                            style="cursor: pointer"
                            class="column-text"
                            target="_blank"
                            v-bind:href="getKnowledgeBaseUrl(props.row)">
                            {{props.row.malware_family}}</a></p>
                        <p v-else class="column-text">{{props.row.malware_family}}</p>
                    </div>
                    <div class="button-container kill-chain-button" slot="sha1" slot-scope="props"
                         style="text-align: left">
                        <p @mouseover="onMouseOverTip($event, props.row.has_kill_chain)" @mouseout="onMouseOutTip()"
                           @click="clickKillChain(props.row)"><a
                            :class="determineClassNameForKillChainButton(props.row.has_kill_chain)"
                            style="cursor: pointer"
                            v-show="showOrHideKillChain(props.row)"
                            v-if="killChainColumn" target="_blank"><img class="kill-chain"
                                                                        src="../../assets/radar.png"
                                                                        width="24" height="24"></a></p>
                        <p class="sha-text">{{getShaOneText(props)}}</p>
                    </div>
                    <div class="button-container kill-chain-button" slot="sha" slot-scope="props"
                         style="text-align: left">
                        <p @mouseover="onMouseOverTip($event, props.row.has_kill_chain)" @mouseout="onMouseOutTip()"
                           @click="clickKillChain(props.row)"><a
                            :class="determineClassNameForKillChainButton(props.row.has_kill_chain)"
                            style="cursor: pointer"
                            v-show="showOrHideKillChain(props.row)"
                            v-if="killChainColumn" target="_blank"><img class="kill-chain"
                                                                        src="../../assets/radar.png"
                                                                        width="24" height="24"></a></p>
                        <p class="sha-one-text">{{getShaText(props)}}</p>
                    </div>
                    <div class="button-container" slot="notify_type" slot-scope="props" style="text-align: center">
                        <div class="circle" :style="{ backgroundColor: props.row.notify_type.color }"></div>
                    </div>
                    <div class="button-container" slot="resolution_status" slot-scope="props"
                         style="text-align: center">
                        <select class="select_box_resolution_status" v-model="props.row.resolution_status">
                            <option v-for="res_status in resolution_status" :value="res_status.id">{{res_status.text}}
                            </option>
                        </select>
                    </div>
                    <div class="button-container" slot="resolutionDropBox" slot-scope="props"
                         style="text-align: center">
                        <div>

                        </div>
                    </div>
                    <div class="current_status" slot="current_status" slot-scope="props" style="text-align: center">
                        <div class="current_status_color"
                             :style="{backgroundColor: getCurrentStatus(props)}"
                             style="float: left;"></div>
                        <div class="current_status_date" @mouseover="onMouseOverCurrentStatus($event, props.row)"
                             @mouseout="onMouseOutCurrentStatus()"
                             v-html="props.row.resolution_status_backup === 2 ? getCurrentStatusDay(props) : ''"></div>
                    </div>
                </v-server-table>
                <image-display-modal ref="imageDisplayModal"
                                     style="max-width: 100%; max-height: 100%"></image-display-modal>
                <url-display-modal ref="urlDisplayModal"></url-display-modal>
                <global-tooltip ref="globalTooltip"></global-tooltip>
            </div>
        </div>
    </div>
</template>

<script>

    const DISPLAY_BOTH = "displayBoth";
    const REQUEST_TIMEOUT = 30 * 1000;

    const PAGE_TYPE_NOTIFICATION = 1;
    const PAGE_TYPE_PARTNER = 2;
    const PAGE_TYPE_GLOBAL = 3;
    const PAGE_TYPE_INDUSTRY = 4;

    const STOLEN_NOT_NOTIFIED = 0;
    const STOLEN_NOTIFIED = 1;
    const STOLEN_PASS_CHANGED = 2;

    const SERVER_TABLE_ID = "serverTable";
    const CLIENT_TABLE_ID = "clientTable";

    import moment from 'moment-timezone';
    import Common from '@/utils/Common.vue';
    import ImageDisplayModal from '@/components/modals/ImageDisplayModal.vue';
    import UrlDisplayModal from '@/components/modals/UrlDisplayModal.vue';
    import GlobalTooltip from '@/components/tooltip/GlobalTooltip.vue';
    import ThreatSummary from '@/components/threat-summary/ThreatSummary.vue';

    import {EventBus} from '@/utils/EventBus.js';
    import {mapGetters} from 'vuex';
    import Constants from '@/utils/constants';
    import PageNumbers from '@/utils/page-number-constants';
    import LoadingModal from '@/components/modals/LoadingModal.vue'

    export default {
        name: "data-table",
        components: {
            ImageDisplayModal: ImageDisplayModal,
            UrlDisplayModal: UrlDisplayModal,
            GlobalTooltip: GlobalTooltip,
            LoadingModal: LoadingModal,
            ThreatSummary: ThreatSummary
        },
        mixins: [Common],
        props: {
            dateColumns: {
                type: Array,
                required: false
            },
            screenshotColumns: {
                type: Array,
                required: false
            },
            clientPagination: {
                type: Boolean,
                required: true
            },
            url: {
                type: String,
                required: true
            },
            cols: {
                type: Array,
                required: true
            },
            orderBy: {
                type: Object,
                required: true
            },
            title: {
                type: String
            },
            httpMethod: {
                type: String,
                default: 'post'
            },
            requestParams: {
                type: Object
            },
            dataPath: {
                type: String,
                required: true
            },
            hasTooltipColumn: {
                type: Boolean
            },
            filterableGlobal: {
                type: Boolean
            },
            exportable: {
                type: Boolean,
                default: true
            },
            settingsPermission: {
                type: String,
                default: null
            },
            isStolen: {
                type: Boolean,
                default: false
            },
            fullPageName: {
                type: String,
                default: 'Unkown Page',
                required: false
            },
            partnerId: {
                type: Number,
                default: null,
                required: false
            },
            tableName: {
                type: String,
                required: false
            },
            isNotification: {
                type: Boolean,
                required: false
            },
            saveResolutionChanges: {
                type: Function,
                required: false
            },
            isSummaryVisible: {
                type: Boolean,
                required: false
            },
            isDataTableVisible: {
                type: Boolean,
                required: false,
                default: true
            },
            toggleLoading: {
                type: Function,
                required: false
            },
            summaryRequestParams: {
                type: Object,
                required: false
            },
            pageContainerId: {
                type: String,
                required: false
            },
            isSettingsPage: {
                type: Boolean,
                required: false,
                default: false
            },
            isStixExportAvailable: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        data() {
            return {
                killChainStatus: false,
                tableData: [],
                displayBothIds: [],
                displayBothChoicesForFilter: [],
                lastRequestParams: {},
                partnerNames: [],
                eyeGlobalOpen: false,
                show_poc_alert: false,
                appliedFilter: [],
                log_start: Date.now(),
                dontMssp: true,
                resolution_status: [
                    Constants.ResolutionStatus.OPEN,
                    Constants.ResolutionStatus.INPROGRESS,
                    Constants.ResolutionStatus.RESOLVED,
                ],
                summarySelectedState: -1,
                summaryStatistics: null,
                isSummaryFetched: false,
                globalDate: null,
                globalDatePickerOpenedFor: null,
                dateSortObject: null,
                filteredDate: null,
                isSummaryClicked: false,
                isFirstRequest: true,
                totalPageCount: 0,
                dataTableTextOptions: ["Showing {from} to {to} of {count} records", "{count} records", "One record"],
                tableType: null,
                totalDataCount: 0,
                dataTableDateFormat: 'YYYY.MM.DD HH:mm:ss',
                lastRequestFilters: null,
                dateSearchDict: {},
                selectedExportValue: -1
            }
        },
        computed: {
            columns() {
                return this.cols.map(c => c.column);
            },
            headings() {
                var headings = {};
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].column == "eye") {
                        headings[this.cols[i].column] = function (h) {
                            return h('div', {
                                attrs: {
                                    id: 'topDivEye',
                                }
                            }, [
                                h('p', {
                                    attrs: {
                                        id: 'topPEye',
                                    }
                                }, this.cols[i].eyeColumnName),
                                this.eyeColumn && this.dontMssp ?
                                    h('img', {
                                        on: {
                                            click: (e) => {
                                                this.onGlobalEyeClick();
                                            }
                                        },
                                        attrs: {
                                            id: 'topImgEye',
                                            src: 'https://threatintelprodimages.valkyrie.comodo.com/eye-open.png'
                                        },
                                        style: {
                                            width: '24px',
                                            height: '24px',
                                            marginRight: '4px'
                                        }
                                    }) : null
                            ])
                        };
                        // headings[this.cols[i].column] = "eye";
                    } else if (this.cols[i].column == "checkboxRow") {
                        headings[this.cols[i].column] = function (h) {
                            return h('input', {
                                attrs: {
                                    type: 'checkbox',
                                    id: 'selectAllCheckbox'
                                },
                                style: {
                                    width: '100%'
                                },
                                on: {
                                    click: (e) => {
                                        this.selectAll(e.srcElement.checked)
                                    }
                                },
                                ref: 'selectAllCheckbox'
                            })
                        };
                    } else if (this.dateColumns.filter(oneColumn => oneColumn.column === this.cols[i].column).length) {
                        var concerningDateColumn = this.dateColumns.filter(oneColumn => oneColumn.column === this.cols[i].column);
                        headings[this.cols[i].column] = function (h) {
                            var headerContents = [
                                h('p', {
                                    attrs: {
                                        id: 'topP',
                                    },
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    on: {
                                        click: (e) => {
                                            this.dateSortClickHandler(i, this.cols[i].column)
                                        }
                                    }
                                }, this.cols[i].title)
                            ];

                            if (!concerningDateColumn[0].hideDateFilter) {
                                var imageElement = h('img', {
                                    on: {
                                        click: (e) => {
                                            this.datePickerClickHandler(e, this.cols[i].column)
                                        }
                                    },
                                    attrs: {
                                        id: 'topImg',
                                        src: 'https://threatintelprodimages.valkyrie.comodo.com/calendar.png'
                                    },
                                    style: {
                                        width: '32px',
                                        height: '24px',
                                        paddingLeft: '8px',
                                        cursor: 'pointer'
                                    }
                                });
                                headerContents.push(imageElement);
                            }

                            return h('div', {
                                attrs: {
                                    id: 'topDiv',
                                }
                            }, headerContents);
                        };
                    } else {
                        headings[this.cols[i].column] = this.cols[i].title;
                    }
                }
                return headings;
            },
            templates() {
                var templates = {};
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].template)
                        templates[this.cols[i].column] = this.cols[i].template;
                }
                return templates;
            },
            sortable() {
                var columns = [];
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].column == "eye" || this.cols[i].column == "checkboxRow" || this.cols[i].column == "resolution_status" || this.cols[i].column == "masked_password" || this.dateColumns.filter(oneDateColumn => oneDateColumn.column === this.cols[i].column).length > 0)
                        continue;
                    else
                        columns.push(this.cols[i].column);
                }
                return columns;
            },
            filterable() {
                if (!this.filterableGlobal && !this.clientPagination)
                    return false;
                var columns = [];
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].column == "eye" || this.cols[i].column == "deleteRow" || this.cols[i].column == "editRow" || this.cols[i].column == "masked_password"
                        || this.cols[i].column == "download" || this.cols[i].column == "details" || this.cols[i].column == "ssThumbnail"
                        || this.cols[i].column == "emailSlot" || this.cols[i].column == "urlCount" || this.cols[i].column == "userCountTooltip"
                        || this.cols[i].column == "editDeleteRow" || this.cols[i].column == "checkboxRow" || this.cols[i].column == "current_status")
                        continue;
                    else
                        columns.push(this.cols[i].column);
                }
                return columns;
            },
            columnsClasses() {
                var classes = {};
                this.cols.forEach(c => classes[c.column] = c.class);
                return classes;
            },
            eyeColumn() {
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].column == "eye") {
                        return this.cols[i].eyeColumnName;
                    }
                }
            },
            killChainColumn() {
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].column === "sha1" || this.cols[i].column === 'sha') {
                        return this.cols[i].killChainColumnName;
                    }
                }
            },
            malwareFamilyColumn() {
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].column === "type" || this.cols[i].column === "malware_family") {
                        return this.cols[i].malwareFamilyColumnName;
                    }
                }
            },
            tooltipColumn() {
                var arr = [];
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].column == "tooltipCell") {
                        arr.push(this.cols[i].display_value);
                    }
                }
                return arr.length ? arr : false
            },
            dataKeys() {
                if (this.dataPath.length == 0)
                    return [];
                else
                    return this.dataPath.split(".");
            },
            tableClasses() {
                var classes;
                if (this.getScrollbarWidth == 0)
                    classes = "table vi-datatable table-scrollable header-fixed ";
                else
                    classes = "table vi-datatable table-scrollable header-fixed datatable-scroll-hidden ";

                if (this.getResponsiveState != this.RESPONSIVE_BIG)
                    classes += "datatable-collapsed";

                return classes;
            },
            options() {
                var self = this;
                var ops = {
                    sendEmptyFilters: true,
                    headings: this.headings,
                    orderBy: this.orderBy,
                    pagination: {chunk: 5, edge: false, dropdown: false},
                    skin: this.tableClasses,
                    sortIcon: {base: 'asd', up: 'asd-chevron-up', down: 'asd-chevron-down', is: 'asd-sort'},
                    dateFormat: "YYYY.MM.DD HH:mm:ss",
                    columnsClasses: this.columnsClasses,
                    requestFunction: this.clientPagination ? undefined : this.requestFunction,
                    responseAdapter: this.clientPagination ? undefined : this.responseAdapter,
                    toMomentFormat: "YYYY.MM.DD HH:mm:ss",
                    customSorting: {
                        displayBoth: function (ascending) {
                            return function (a, b) {
                                var aValue = self.displayBoth({row: a});
                                var bValue = self.displayBoth({row: b});
                                if (aValue < bValue) return ascending ? -1 : 1;
                                if (aValue > bValue) return ascending ? 1 : -1;
                                return 0;
                            }
                        }
                    },
                    perPage: 25,
                    uniqueKey: "datatable-id",
                    perPageValues: this.clientPagination ? [25] : [25, 50, 100, 1000],
                    sortable: this.sortable,
                    filterable: this.filterable,
                    templates: this.templates,
                    listColumns: {
                        enterprise_id: this.partnerNames,
                        notify_type: [{
                            id: 0,
                            text: 'Not Notified'
                        }, {
                            id: 1,
                            text: 'Notified'
                        }, {
                            id: 2,
                            text: 'Password Changed'
                        }],
                        resolution_status: [
                            Constants.ResolutionStatus.OPEN,
                            Constants.ResolutionStatus.INPROGRESS,
                            Constants.ResolutionStatus.RESOLVED,
                        ]
                    }
                };

                if (this.clientPagination || this.filterableGlobal)
                    ops.filterByColumn = true;

                // if (this.dateColumns)
                // ops.dateColumns = this.dateColumns;

                return ops;
            },
            hasDisplayBoth() {
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].column == DISPLAY_BOTH)
                        return true;
                }
                return false;
            },
            isExportPermitted() {
                var manName = this.getComodoAdminName;
                if ((manName === undefined || manName === null || manName === '') && (this.getIsPrimaryUser === "False")) {
                    var page = this.getSelectedPage;
                    var permissionList = [];
                    var user_permissions = this.getUserPermissions;
                    if (user_permissions != null) {
                        if (page.page_type == PAGE_TYPE_NOTIFICATION) {
                            permissionList = user_permissions.notification_permissions.export_permissions;
                        } else if (page.page_type == PAGE_TYPE_GLOBAL) {
                            permissionList = user_permissions.global_permissions.export_permissions;
                        } else if (page.page_type == PAGE_TYPE_PARTNER) {
                            permissionList = user_permissions.partner_permissions.export_permissions;
                        } else if (page.pageNumber == PageNumbers.SETTINGS.number) {
                            //Settings page case
                            permissionList = user_permissions.settings_permissions.export_permissions;
                            page.permission_id = this.settingsPermission;
                        }

                        if (permissionList.indexOf(page.permission_id) != -1) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },
            setExportClass() {
                if (this.isExportPermitted) {
                    return "grow export-csv-button";
                } else {
                    return "disabled-export export-csv-button";
                }
            },
            ...mapGetters([
                "getResponsiveState",
                "getScrollbarWidth",
                "getUserPermissions",
                "getComodoAdminName",
                "getSelectedPage",
                "getIsPrimaryUser",
                "getSelectedPartner",
                "getPlatformKillChainEndPoint",
                "getComodoUserObject",
                "getEnterpriseName",
                "getEnterpriseId",
                "getComodoAdminRole"
            ])
        },
        methods: {
            checkIfDateFiltered(data, oldData) {
                if (!oldData) {
                    return false;
                }
                for (let key in data) {
                    if (data[key] !== oldData[key]) {
                        if (this.dateColumns.filter(oneDateColumn => oneDateColumn.column === key).length) {
                            /**
                             * last filter is one of date column
                             */
                            return true;
                        }
                    }
                }
                return false;
            },
            paginationInputHandler(e) {
                let page = !this.clientPagination ? $("#paginatorInput").val() : $("#" + this.pageContainerId + " #paginatorInput").val();
                page = Math.round(page);
                if (page > this.totalPageCount || page < 1) {
                    // this.$toasted.show("Please enter a valid page between 1 and " + this.totalPageCount, {
                    //     position: "bottom-center",
                    //     duration: 5000,
                    //     type: 'error'
                    // });
                    if (this.tableType === SERVER_TABLE_ID) {
                        $("#paginatorInput").val(this.$refs[this.tableType].page);
                    } else {
                        $("#" + this.pageContainerId + " #paginatorInput").val(this.$refs[this.tableType].page);
                    }

                } else {
                    this.$refs[this.tableType].page = page;
                    if (this.tableType === SERVER_TABLE_ID) {
                        this.refreshServerSidePage();
                    } else {
                        this.adjustTotalPage(this.totalDataCount);
                        this.refresh();
                    }
                }

            },
            dateSortClickHandler(index, columnName) {
                /**
                 * date has been sorted
                 */
                let dateObject = this.dateColumns.filter(oneDataColumn => oneDataColumn.column === columnName)[0];
                this.dateSortObject = {
                    index: index,
                    order: dateObject.isAsc ? 'asc' : 'desc'
                };
                dateObject.isAsc = !dateObject.isAsc;
                this.refreshServerSidePage();
            },
            datePickerClickHandler(e, columnName) {
                this.globalDatePickerOpenedFor = columnName;
                this.$refs['date-picker-global'].open(e);
            },
            nextPageClicked() {
                this.$refs[this.tableType].page = this.totalPageCount;
                if (this.tableType === SERVER_TABLE_ID) {
                    this.refreshServerSidePage();
                } else {
                    // $("#" + this.pageContainerId + " #paginatorInput").val(this.totalPageCount);
                    this.adjustTotalPage(this.totalDataCount);
                    this.refresh();
                }
            },
            previousPageClicked() {
                this.$refs[this.tableType].page = 1;
                if (this.tableType === SERVER_TABLE_ID) {
                    this.refreshServerSidePage();
                } else {
                    // $("#" + this.pageContainerId + " #paginatorInput").val(1);
                    this.adjustTotalPage(this.totalDataCount);
                    this.refresh();
                }
            },
            adjustTotalPage(totalCount) {
                if (totalCount === 0) {
                    this.deleteOlderPaginationElements();
                    return;
                }
                let paginationDivElement = document.createElement('div');
                paginationDivElement.setAttribute("id", "paginationDiv");
                let paginationElement = !this.clientPagination ? $(".VuePagination") : $("#" + this.pageContainerId + " .VuePagination");
                let paginationInfoContainer = !this.clientPagination ? $(".VuePagination nav") : $("#" + this.pageContainerId + " .VuePagination nav");

                let page = this.$refs[this.tableType].page;
                let limit = this.$refs[this.tableType].limit;
                let totalPage = Math.ceil(totalCount / limit);
                this.totalPageCount = totalPage;

                let totalPageNumberElement = document.createElement('p');
                totalPageNumberElement.setAttribute("id", "paginationTotalPage");
                let textElement = document.createTextNode(totalPage);
                totalPageNumberElement.appendChild(textElement);

                let slashElement = document.createElement('p');
                slashElement.setAttribute("id", "paginationSlash");
                let slashTextElement = document.createTextNode('/');
                slashElement.appendChild(slashTextElement);

                let firstPageElement = document.createElement('img');
                firstPageElement.src = "https://threatintelprodimages.valkyrie.comodo.com/vti_ui/back.png";
                firstPageElement.setAttribute("id", "firstPagePaginator");
                firstPageElement.style.cursor = 'pointer';
                firstPageElement.style.visibility = parseInt(page) !== 1 ? 'visible' : 'hidden';
                firstPageElement.addEventListener('click', parseInt(page) !== 1 ? this.previousPageClicked : null);

                let lastPageElement = document.createElement('img');
                lastPageElement.src = "https://threatintelprodimages.valkyrie.comodo.com/vti_ui/next.png";
                lastPageElement.setAttribute("id", "lastPagePaginator");
                lastPageElement.style.cursor = 'pointer';
                lastPageElement.style.visibility = parseInt(page) !== totalPage ? 'visible' : 'hidden';
                lastPageElement.addEventListener('click', parseInt(page) !== totalPage ? this.nextPageClicked : null);

                let inputElement = document.createElement('input');
                inputElement.setAttribute("id", "paginatorInput");
                inputElement.setAttribute("value", page);
                inputElement.setAttribute("type", "number");
                inputElement.setAttribute("min", 1);
                inputElement.setAttribute("max", this.totalPageCount);
                inputElement.addEventListener('change', this.paginationInputHandler);
                // inputElement.addEventListener('change', this.paginationInputHandler);

                let infoText = document.createElement('p');
                infoText.setAttribute("id", "paginationInfoText");
                let i = Math.min(totalCount === 1 ? 2 : this.totalPageCount === 1 ? 1 : 0, this.dataTableTextOptions.length);
                let from = (page - 1) * limit + 1;
                let to = parseInt(page) === totalPage ? totalCount : parseInt(from) + parseInt(limit) - 1;
                let text = this.dataTableTextOptions[i].replace('{count}', totalCount).replace('{from}', from).replace('{to}', to);
                let infoTextElement = document.createTextNode(text);
                infoText.appendChild(infoTextElement);

                this.deleteOlderPaginationElements();

                paginationInfoContainer.append(infoText);
                paginationDivElement.append(inputElement);
                paginationDivElement.append(slashElement);
                paginationDivElement.append(totalPageNumberElement);
                paginationDivElement.prepend(firstPageElement);
                paginationDivElement.append(lastPageElement);
                paginationElement.append(paginationDivElement);
            },
            deleteOlderPaginationElements() {
                if (!this.clientPagination) {
                    $("#paginationInfoText").remove();
                    $("#paginatorInput").remove();
                    $("#firstPagePaginator").remove();
                    $("#paginationSlash").remove();
                    $("#lastPagePaginator").remove();
                    $("#paginationTotalPage").remove();
                } else {
                    $("#" + this.pageContainerId + " #paginationInfoText").remove();
                    $("#" + this.pageContainerId + " #paginatorInput").remove();
                    $("#" + this.pageContainerId + " #firstPagePaginator").remove();
                    $("#" + this.pageContainerId + " #paginationSlash").remove();
                    $("#" + this.pageContainerId + " #lastPagePaginator").remove();
                    $("#" + this.pageContainerId + " #paginationTotalPage").remove();
                }
            },
            summaryItemClicked(summaryEnum) {
                if (this.isDataTableVisible && this.summarySelectedState !== summaryEnum) {
                    for (let key in this.$refs['serverTable'].query) {
                        if (this.dateColumns.filter(oneDate => oneDate.column === key).length) {
                            this.$refs['serverTable'].query[key] = '';
                        }
                    }
                    this.summarySelectedState = summaryEnum;
                    this.isSummaryClicked = true;
                    this.$refs.serverTable.setPage(1);
                    this.refreshServerSidePage();
                }
            },
            getFilterLogEntry(data) {
                let appliedFilter = this.appliedFilter;
                let keys = Object.keys(this.lastRequestParams.query);
                let filter = '';
                let filterClear = false;

                for (let i = 0; i < keys.length; i++) {
                    let index = appliedFilter.indexOf(keys[i]);
                    if (index > -1 && data.query[keys[i]] === '') {
                        appliedFilter.splice(index, 1);
                        filterClear = true;
                    } else {
                        appliedFilter.push(keys[i]);
                        if (data.query[keys[i]] !== '') {
                            filter += keys[i] + ": " + data.query[keys[i]] + ", ";
                        }
                    }
                }

                if (filter !== '') {
                    filter = filter.substring(0, filter.length - 2);
                    if (data.limit === 'ALL') {
                        return {"action": Constants.TableActions.CsvExport, "additionalInfo": filter}
                    } else {
                        return {"action": Constants.TableActions.FilterApplied, "additionalInfo": filter}
                    }
                } else {
                    if (data.limit === 'ALL') {
                        return {"action": Constants.TableActions.CsvExport, "additionalInfo": null}
                    } else {
                        return {"action": Constants.TableActions.FilterCleared, "additionalInfo": null}
                    }
                }
            },
            getHttpPromise(params) {
                if (this.httpMethod === 'post') {
                    return this.$http.post(this.url, params, {timeout: REQUEST_TIMEOUT});
                } else {
                    return this.$http.get(this.url, {params: params, timeout: REQUEST_TIMEOUT});
                }
            },
            requestFunction(data) {
                let filter = false;
                if (this.lastRequestParams != null && this.lastRequestParams.query != null) {
                    let filterKeys = Object.keys(this.lastRequestParams.query);

                    for (let i = 0; i < filterKeys.length; i++) {
                        if (this.lastRequestParams.query[filterKeys[i]] !== '') {
                            filter = true;
                            break;
                        }
                    }
                }

                let logEntry = null;
                if (Object.keys(this.lastRequestParams).length < 1) {
                    logEntry = {"action": Constants.TableActions.PageOpened, "additionalInfo": null};
                } else if (this.lastRequestParams.orderBy != data.orderBy || this.lastRequestParams.ascending != data.ascending) {
                    let orderByInfo = "Column name: " + data.orderBy + ", ";
                    orderByInfo += data.ascending == 1 ? "ascending" : "descending";
                    logEntry = {"action": Constants.TableActions.OrderByApplied, "additionalInfo": orderByInfo};
                } else if (this.lastRequestParams.limit != data.limit) {
                    let record_count_changed_info = this.lastRequestParams.limit + " to " + data.limit;
                    logEntry = {
                        "action": Constants.TableActions.RecordsPerPageChanged,
                        "additionalInfo": record_count_changed_info
                    };
                } else if (data.page === 1 && this.lastRequestParams.page !== data.page && filter) {
                    logEntry = this.getFilterLogEntry(data);
                } else if (this.lastRequestParams.page != data.page) {

                    let page_changed_info = this.lastRequestParams.page + " to " + data.page;
                    logEntry = {"action": Constants.TableActions.PageChanged, "additionalInfo": page_changed_info};

                } else {
                    logEntry = this.getFilterLogEntry(data);
                }

                this.lastRequestParams = Object.assign({}, data);
                var requestData = {
                    draw: data.page,
                    length: data.limit,
                    order: [{
                        column: this.columns.indexOf(data.orderBy),
                        dir: data.ascending ? "asc" : "desc"
                    }],
                    searchString: {
                        value: data.query,
                        regex: false,
                        dateSearchDict: this.dateSearchDict,
                        timezone: moment.tz.guess()
                    },
                    start: (data.page - 1) * data.limit,
                    logEntry: logEntry,
                    summaryType: this.summarySelectedState,
                    is_first_request: this.isFirstRequest,
                    is_stix_export: data.stixExport
                };
                if (this.dateSortObject) {
                    requestData.order = [{column: this.dateSortObject.index, dir: this.dateSortObject.order}]
                }
                if (this.filteredDate) {
                    requestData.searchString.value[this.globalDatePickerOpenedFor] = this.filteredDate;
                    this.$refs.serverTable.query[this.globalDatePickerOpenedFor] = this.filteredDate;
                    $('input[name=vf__' + this.globalDatePickerOpenedFor + ']').val(this.filteredDate);
                    this.filteredDate = null;
                }
                /**
                 * adjusting date ranges
                 */
                let isLastFilterIsDate = this.checkIfDateFiltered(data.query, this.lastRequestFilters);
                if (isLastFilterIsDate) {
                    for (let i = 0; i < this.dateColumns.length; i++) {
                        for (let key in requestData.searchString.value) {
                            if (this.dateColumns.filter(oneDate => oneDate.column === key).length) {
                                if (data.query[key] !== this.lastRequestFilters) {
                                    if (data.query[key] && data.query[key] != "") {
                                        let result = this.changeGivenDateToRange(data.query[key]);
                                        if (result.isSearching) {
                                            this.dateSearchDict[key] = result;
                                            requestData.searchString.dateSearchDict = this.dateSearchDict;
                                        } else {
                                            this.loaded();
                                            return;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                this.lastRequestFilters = Object.assign({}, data.query);
                var page = this.getSelectedPage;
                if (page.page_type == PAGE_TYPE_PARTNER) {
                    var partnerID = this.getSelectedPartner;
                    requestData.partner_id = partnerID;
                }

                var displayBothChoices = this.displayBothChoices();
                if (displayBothChoices) {
                    requestData.searchString.display_both_columns = displayBothChoices;
                }

                if (this.requestParams) {
                    requestData = Object.assign(requestData, this.requestParams);
                }

                var promise = this.getHttpPromise(requestData);
                this.$emit("toggleLoading", true);
                return promise
                    .then(
                        // Success
                        response => {
                            // response.data.return_code === "Success"

                            // show poc alert here
                            this.show_poc_alert = response.data.data.show_poc_limitation_alert;
                            if (this.show_poc_alert != undefined && this.show_poc_alert) {
                                this.$toasted.show("PoC Mode - Limited Data Shown", {
                                    position: "bottom-center",
                                    duration: 2000,
                                    type: 'error'
                                });
                            }

                            if (document.getElementById("selectAllCheckbox") != null) {
                                document.getElementById("selectAllCheckbox").checked = false;
                            }
                            this.$emit("toggleLoading", false);
                            this.isFirstRequest = false;
                            return response.data;
                        },
                        // Error
                        response => {
                            this.$emit("toggleLoading", false);
                            this.isFirstRequest = false;
                            return [];
                        }
                    )
                    .bind(this);
            },
            responseAdapter(response) {
                this.tableType = SERVER_TABLE_ID;
                this.adjustTotalPage(response.data.total);
                return {
                    data: this.formatData(this.parseData(response)),
                    count: response.data.total
                }
            },
            parseData(responseData) {
                var data = responseData;
                var keys = this.dataKeys;

                if (keys.length == 0)
                    return responseData;

                for (let i = 0; i < keys.length; i++) {
                    let key = keys[i];
                    data = data[key];
                }
                return data;
            },
            formatData(data) {
                if (this.hasDisplayBoth) {
                    for (let i = 0; i < data.length; i++) {
                        data[i].displayBoth = this.displayBoth(data[i]);
                    }
                }
                if (this.eyeColumn) {
                    for (let i = 0; i < data.length; i++) {
                        this.$set(data[i], 'secure', true);
                        this.$set(data[i], 'eyeText', data[i][this.eyeColumn]);
                        this.$set(data[i], 'datatable-id', i);
                    }
                }
                if (this.dateColumns) {
                    for (let i = 0; i < data.length; i++) {
                        for (let j = 0; j < this.dateColumns.length; j++) {
                            let dateColumnName = this.dateColumns[j].column;
                            let formattedDate = this.utcStringToLocalDate(data[i][dateColumnName], this.dataTableDateFormat);
                            this.$set(data[i], dateColumnName, formattedDate);
                        }
                    }
                }
                if (this.screenshotColumns) {
                    for (let i = 0; i < data.length; i++) {
                        for (let j = 0; j < this.screenshotColumns.length; j++) {
                            let screenshotColumnName = this.screenshotColumns[j].column;
                            let urlColumnName = this.screenshotColumns[j].urlColumn;
                            if (data[i]["blur"]) {
                                this.$set(data[i], Constants.DatatableSS, Constants.ScreenShotStatic);
                            } else {
                                this.$set(data[i], "datatableSS", data[i][screenshotColumnName]);
                            }
                            this.$set(data[i], "datatableUrl", data[i][urlColumnName]);
                        }
                    }
                }
                if (this.tooltipColumn) {
                    for (let i = 0; i < data.length; i++) {
                        let d = data[i];
                        d.displayedTooltipCount = -1 * this.tooltipColumn.length;
                        d.idCount = 0;
                        for (let j = 0; j < this.tooltipColumn.length; j++) {
                            this.$set(data[i], "value-" + j, d[this.tooltipColumn[j]]);
                        }
                    }
                }
                this.tableData = data;
                return data;
            },
            getTooltipCell(row, val_name, increment) {
                var t = row["value-" + row.displayedTooltipCount];
                var r_value = null;
                if (t) {
                    if (val_name == "tooltip") {
                        r_value = t.tooltip.length ? t.tooltip.join('<br/>') : "No Data";
                    } else {
                        r_value = t[val_name];
                    }
                }

                if (increment) {
                    row.displayedTooltipCount = row.displayedTooltipCount + 1;
                }

                return r_value;
            },
            getTooltipId(row, increment) {
                var t = row["value-" + row.idCount];
                var r_value = null;
                if (t) {
                    r_value = t["id"];
                }

                if (increment) {
                    row.idCount = row.idCount + 1;
                }

                return r_value;
            },
            getPartnerList() {
                if (this.getUserRole(this.getComodoAdminRole) == "TI_VI_MSSP_USER") {
                    this.dontMssp = false;
                }
                if (this.cols.some(s => s.title === "Partner Name")) {
                    let self = this;
                    let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/partners/get', {verbose: false});
                    promise.then(successData => {
                            successData.data.data.forEach(d => {
                                self.partnerNames.push({
                                    id: d.customer_id,
                                    text: d.customer_name
                                })
                            });
                        },
                        failData => {
                            // console.log(JSON.stringify(failData));
                        }
                    )
                }
            },
            getDataForClientPagination() {
                this.loading();
                var requestData = this.requestParams;
                var page = this.getSelectedPage;
                if (page.page_type == PAGE_TYPE_PARTNER) {
                    var partnerID = this.getSelectedPartner;
                    requestData.partner_id = partnerID;
                }

                var promise = this.getHttpPromise(requestData);

                promise
                    .then(
                        // Success
                        response => {

                            this.tableData = this.formatData(this.parseData(response.data));
                            this.loaded();
                            this.tableType = CLIENT_TABLE_ID;
                            this.totalDataCount = response.data.data.length;
                            this.adjustTotalPage(response.data.data.length);
                        },
                        // Error
                        response => {
                            this.tableData = [];
                            this.loaded();
                        }
                    )
            },
            displayBoth(row) {
                var searchedColumn;
                for (let i = 0; i < this.cols.length; i++) {
                    let column = this.cols[i];
                    if (column.column === DISPLAY_BOTH) {
                        if (this.displayBothIds.indexOf(row.id) === -1) {
                            searchedColumn = column;
                            this.displayBothIds.push(row.id);
                            break;
                        } else {
                            searchedColumn = column;
                            break;
                        }
                    }
                }

                if (!searchedColumn) return;
                var value1 = row[searchedColumn.choices[0]];
                var value2 = row[searchedColumn.choices[1]];

                if (value1 && value2)
                    return value1 + " / " + value2;
                else if (value1) {
                    return value1;
                } else {
                    return value2;
                }
            },
            displayBothChoices() {
                for (let i = 0; i < this.cols.length; i++) {
                    if (this.cols[i].column == DISPLAY_BOTH) {
                        return this.cols[i].choices;
                    }
                }
            },
            getEyeText(props) {
                if (this.eyeGlobalOpen) {
                    return props.row.eyeText;
                } else {
                    if (props.row.secure)
                        return "********";
                    else
                        return props.row.eyeText;
                }
            },
            getShaOneText(props) {
                return props.row.sha1
            },
            getShaText(props) {
                return props.row.sha
            },
            getCurrentStatus(props) {
                if (props.row.resolution_status_backup === Constants.ResolutionStatus.OPEN.id) {
                    return "#FF0045";
                } else if (props.row.resolution_status_backup === Constants.ResolutionStatus.INPROGRESS.id) {
                    return "#FFD137";
                } else if (props.row.resolution_status_backup === Constants.ResolutionStatus.RESOLVED.id) {
                    return "#80D431";
                } else {
                    return '#FF0045';
                }
            },
            getCurrentStatusDay(props) {
                if (props.row.resolution_status_backup === Constants.ResolutionStatus.RESOLVED.id) {
                    if (props.row.resolution_duration !== undefined) {
                        if (props.row.resolution_duration === 0) {
                            return ' Last Day'
                        } else {
                            return props.row.resolution_duration <= 1 ? props.row.resolution_duration + ' day' : props.row.resolution_duration + ' days';
                        }
                    } else {
                        return '';
                    }
                } else {
                    return '';
                }
            },
            isEyeOpen(props) {
                return !props.row.secure || this.eyeGlobalOpen;
            },
            refresh() {
                if (this.clientPagination) {
                    this.getDataForClientPagination();
                } else {
                    this.requestFunction(this.lastRequestParams);
                }
            },
            refreshServerSidePage() {
                this.$refs.serverTable.getData();
            },
            onDetailsClick(row) {
                this.$emit("onDetailsClick", row);
            },
            onDownloadClick(row) {
                this.$emit("onDownloadClick", row);
            },
            onEditClick(row) {
                this.$emit("onEditClick", row);
            },
            onDeleteClick(row) {
                this.$emit("onDeleteClick", row);
            },
            onEyeClick(props) {
                props.row.secure = !props.row.secure;
                let log_text = '';
                if (props.row.secure) {
                    log_text = 'Single Row Covered, User Name: ' + props.row.account_username;
                } else {
                    log_text = 'Single Row Revealed, User Name: ' + props.row.account_username;
                }
                this.saveLog(this, this.fullPageName, 'Password Eye Clicked (' + log_text + ')', 0, null);
            },
            onGlobalEyeClick() {
                this.eyeGlobalOpen = !this.eyeGlobalOpen;
                let log_text = '';
                if (this.eyeGlobalOpen) {
                    log_text = 'All Rows Revealed';
                } else {
                    log_text = 'All Rows Covered';
                }
                this.saveLog(this, this.fullPageName, 'Password Eye Clicked (' + log_text + ')', 0, null);
            },
            removeUnneccessaryData(data) {
                data = JSON.parse(data);
                let returnData = data.map((
                    {
                        pcap_valid,
                        enterprise_targeted_malware_id,
                        resolution_status_backup,
                        record_state,
                        feed_id,
                        reputation,
                        enterprise_id,
                        has_kill_chain,
                        id,
                        pcap_origin,
                        displayBoth,
                        enterprise_targeted_phishing_id,
                        blur,
                        enterprise_phishing_sender_id,
                        matched_phishing_hosting_id,
                        phishing_received_id,
                        ...keepAttrs
                    }) => keepAttrs);
                return JSON.stringify(returnData);
            },
            getExportFileNameWithExtension() {
                let title = '';
                let category = 'UnknownCategory';
                let extension = 'csv';

                let enterprseName = this.getEnterpriseName.split(' ').join('').trim();

                switch (this.selectedExportValue) {
                    case Constants.ExportTypes.CSV:
                        extension = 'csv';
                        break;
                    case Constants.ExportTypes.JSON:
                        extension = 'json';
                        break;
                    case Constants.ExportTypes.STIX:
                        extension = 'stix';
                        break;
                }

                if (this.isSettingsPage) {
                    title = 'Settings';

                    switch (this.pageContainerId) {
                        case 'domain-tab':
                            category = 'DomainList';
                            break;
                        case 'ip-tab':
                            category = 'IpList';
                            break;
                        case 'brand-tab':
                            category = 'BrandList';
                            break;
                        case 'account-tab':
                            category = 'AccountList';
                            break;
                        case 'notification-tab':
                            category = 'Notifications';
                            break;
                        case 'licences-tab':
                            category = 'Licences';
                            break;
                    }
                } else {
                    let page_types = {
                        notification: 1,
                        partner: 2,
                        industry: 3,
                        global: 4
                    };

                    title = this.title.split(' ').join('').trim();

                    let currentPage = this.getSelectedPage;
                    if (currentPage.page_type === page_types.global) {
                        category = 'GlobalThreats';
                    } else if (currentPage.page_type === page_types.industry) {
                        category = 'IndustryThreats';
                    } else if (currentPage.page_type === page_types.notification) {
                        category = 'Notifications';
                    } else if (currentPage.page_type === page_types.partner) {
                        category = 'PartnerThreats';
                    }
                }


                let currentDate = new Date();
                let date = this.formatDateYYYYMMDD(currentDate);
                let time = this.formatTimeHHMMSS(currentDate);

                return [enterprseName, title, category, date, time].join('_') + '.' + extension;
            },
            exportCsv() {
                if (this.selectedExportValue === -1) return;

                let fileNameWithExtension = this.getExportFileNameWithExtension();

                let args = {
                    filename: fileNameWithExtension
                };

                if (this.tableName) {
                    this.saveLog(this, this.tableName + ' Export CSV', this.tableName + ' CSV is downloaded', 0, null);
                    let cat_data = {
                        page_name: this.tableName,
                        customer_id: this.getEnterpriseId,
                        customer_name: this.getEnterpriseName
                    };
                    this.saveCatLog(this, Constants.cat_logger.customer_ui_export_csv_cat_logger, cat_data);
                }

                if (this.clientPagination) {
                    switch (this.selectedExportValue) {
                        case Constants.ExportTypes.CSV:
                            let csvProjectionOfData = this.projectionOfColumns(this.tableData, this.cols);
                            this.downloadCSV(csvProjectionOfData, args);
                            break;
                        case Constants.ExportTypes.JSON:
                            this.downloadExportContent(JSON.stringify(this.tableData), fileNameWithExtension);
                            break;
                        case Constants.ExportTypes.STIX:
                            // TODO : STIX Export
                            break;
                    }

                    this.selectedExportValue = -1;

                } else {
                    this.loading();
                    let limit = this.lastRequestParams.limit;
                    this.lastRequestParams.limit = 'ALL';
                    this.lastRequestParams.stixExport = this.selectedExportValue === Constants.ExportTypes.STIX;


                    this.requestFunction(this.lastRequestParams)
                        .then(function (data) {
                            if (data.return_code === 'Unauthorized User') {
                                this.$toasted.show("User hasn't got required permission to export.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                                this.loaded();
                            } else {
                                switch (this.selectedExportValue) {
                                    case Constants.ExportTypes.CSV:
                                        let csvProjectionOfData = this.projectionOfColumns(this.responseAdapter(data).data, this.cols);
                                        this.downloadCSV(csvProjectionOfData, args);
                                        break;
                                    case Constants.ExportTypes.STIX:
                                    case Constants.ExportTypes.JSON:
                                        this.downloadExportContent(JSON.stringify(this.responseAdapter(data).data), fileNameWithExtension);
                                        break;
                                }

                                this.loaded();
                            }

                            this.lastRequestParams.limit = limit;
                            this.selectedExportValue = -1;
                        });
                }
            }
            ,
            saveAllChanges(tableData) {
                this.saveLog(this, this.title, 'Save Changes clicked. Data is: (' + JSON.stringify(tableData) + ')',
                    null, null);
                this.$emit("saveResolutionChanges", tableData);
            }
            ,
            projectionOfColumns(arrayToSave, cols) {
                return arrayToSave.map(function (d) {
                    let csvData = {};
                    cols.forEach(function (column) {
                        if (column.title.toUpperCase() == "ACTIONS") {
                            return;
                        }

                        if (column.column == "eye") {
                            csvData[column.title] = d[column.eyeColumnName] == null ? '' : d[column.eyeColumnName];
                        } else if (column.column == "details" || column.column == "urlCount" || column.column == "download" || column.column == "ssThumbnail" || column.column == "checkboxRow") {
                            return;
                        } else if (column.column == "notify_type") {
                            if (d[column.column].value == 0) {
                                csvData[column.title] = d[column.column] == null ? '' : 'Not Notified';
                            } else if (d[column.column].value == 1) {
                                csvData[column.title] = d[column.column] == null ? '' : 'Notified';
                            } else {
                                csvData[column.title] = d[column.column] == null ? '' : 'Password Changed';
                            }
                        } else if (column.column == "resolution_status") {
                            if (d[column.column] == 0) {
                                csvData[column.title] = d[column.column] == null ? '' : 'Open';
                            } else if (d[column.column] == 1) {
                                csvData[column.title] = d[column.column] == null ? '' : 'In Progress';
                            } else {
                                csvData[column.title] = d[column.column] == null ? '' : 'Resolved';
                            }
                        } else if (column.column == "current_status") {
                            if (d["resolution_duration"] != undefined) {
                                csvData[column.title] = d["resolution_duration"] <= 1 ? d["resolution_duration"] + " day" : d["resolution_duration"] + " days";
                            } else {
                                csvData[column.title] = "";
                            }
                        } else if (column.column != undefined) {
                            csvData[column.title] = d[column.column] == null ? '' : d[column.column];
                        }

                    });
                    return csvData;
                });
            }
            ,
            onImageClick(row) {
                let log_start = Date.now();
                if (row.blur === true) {
                    this.loading();
                    var promise = this.$http.post(this.url + "/screenshot", row, {timeout: REQUEST_TIMEOUT * 10});

                    return promise
                        .then(
                            // Success
                            response => {
                                this.$set(row, "datatableSS", response.data.data["screenshot_path"]);
                                row.blur = response.data.data["blur"];
                                this.loaded();
                                this.saveLog(this, this.fullPageName, 'Screenshot Opened (Screenshot Url: ' + row.datatableSS + ')',
                                    this.getDurationInSeconds(log_start, Date.now()), this.partnerId);
                                this.$refs.imageDisplayModal.openModal(row.datatableSS, row.url);
                            },
                            // Error
                            response => {
                                this.loaded();
                            }
                        )
                        .bind(this);
                } else {
                    this.saveLog(this, this.fullPageName, 'Screenshot Opened (Screenshot Url: ' + row.datatableSS + ')',
                        this.getDurationInSeconds(log_start, Date.now()), this.partnerId);
                    this.$refs.imageDisplayModal.openModal(row.datatableSS, row.url);
                }
            }
            ,
            onEmailClick(row) {
                this.$emit("onEmailClick", row);
            }
            ,
            onTooltipClick(data) {
                this.$emit("tooltipClicked", data);
            }
            ,
            loading() {
                this.$emit("loading");
            }
            ,
            loaded() {
                this.$emit("loaded");
                var self = this;
                setTimeout(function () {
                    self.createTooltips();
                    var table = document.getElementsByClassName('vi-datatable')[0];
                    table.setAttribute('id', self.clientPagination + self.title);
                    new TableResize(document.getElementsByClassName('vi-datatable')[0], {
                        distance: 0,
                        minWidth: 50,
                        restoreState: true,
                        fixed: true
                    }, self);
                }, 500);
            }
            ,
            getTableData() {
                return this.tableData;
            }
            ,
            onUrlCountClick(row) {
                var urls = [];
                if (row.url_count > 0) {
                    urls = row.url.split(',');
                }
                this.$refs.urlDisplayModal.showModal(row.file_name, urls);
            }
            ,
            showOrHide(data) {

                if (((data.pcap == null || data.pcap == '' || data.pcap === 'None')
                    && (data.pcap_origin == null || data.pcap_origin == '' || data.pcap_origin === 'None')) || ((data.pcap_valid !== undefined) && (data.pcap_valid != true))) {
                    return false;
                } else {
                    return true;
                }
            }
            ,
            showOrHideDetail(data) {
                var response = false;
                for (var i = 0; i < this.cols.length; i++) {
                    var col = this.cols[i];
                    if ('detailsRequired' in col) {
                        if (col.detailsRequired != -1) {
                            if (data[col.choices[col.detailsRequired]] != undefined && data[col.choices[col.detailsRequired]] != null
                                && data[col.choices[col.detailsRequired]] != 'None' && data[col.choices[col.detailsRequired]] != '') {
                                response = true;
                            }
                        } else {
                            if (data[col.column] != undefined && data[col.column] != null && data[col.column] != 'None' && data[col.column] != '') {
                                response = true;
                            }
                        }
                    }
                }
                return response;
            }
            ,
            linkToKillChain(data) {
                for (let i = 0; i < this.cols.length; i++) {
                    if (data.sha1 != undefined && data.sha1 != null
                        && data.sha1 != 'None' && data.sha1 != '') {
                        return 'https://valkyrie.comodo.com/kill/chain/' + data.sha1 + '/summary';
                    } else if (data.sha != undefined && data.sha != null
                        && data.sha != 'None' && data.sha != '') {
                        return 'https://valkyrie.comodo.com/kill/chain/' + data.sha + '/summary';
                    }
                }
            }
            ,
            determineClassNameForKillChainButton(status) {
                if (status === true) {
                    return 'kill-chain-button-clicks';
                } else {
                    return 'kill-chain-button-clicks-no-report';
                }
            }
            ,
            onMouseOverTip(e, status) {
                if (status === false) {
                    var self = this;
                    var rect = e.target.getBoundingClientRect();
                    self.$refs.globalTooltip.showTooltip(rect.top + 25, rect.left, 'Kill chain report not exist');
                }
            }
            ,
            onMouseOverCurrentStatus(e, row) {
                let text = '';
                if (row.resolution_status !== Constants.ResolutionStatus.RESOLVED.id) {
                    return;
                } else if (row.resolution_status === Constants.ResolutionStatus.RESOLVED.id) {
                    let remainingDay = '';
                    if (row.resolution_duration !== undefined) {
                        if (row.resolution_duration === 0) {
                            remainingDay = ' Today'
                        } else {
                            remainingDay = row.resolution_duration <= 1 ? row.resolution_duration + ' day' : row.resolution_duration + ' days';
                        }
                    } else {
                        remainingDay = '';
                    }
                    text = 'This resolved threat will be removed from the list after ' + remainingDay + '.';
                }
                var self = this;
                var rect = e.target.getBoundingClientRect();
                self.$refs.globalTooltip.showTooltip(rect.top + 25, rect.left, text);
            }
            ,
            onMouseOutCurrentStatus() {
                this.$refs.globalTooltip.hideTooltip();
            }
            ,
            onMouseOutTip() {
                this.$refs.globalTooltip.hideTooltip();
            }
            ,
            clickKillChain(status) {
                if (status.has_kill_chain === true) {
                    if (status.sha1 !== undefined && status.sha1 !== null
                        && status.sha1 !== 'None' && status.sha1 !== '') {
                        this.saveLog(this, this.title, 'Open Kill Chain Report. (Sha1: ' + status.sha1,
                            this.getDurationInSeconds(this.log_start, Date.now()), null);
                        let openUrl = this.getPlatformKillChainEndPoint + "/" + status.sha1 + "/summary";
                        this.openUrlInIframe(openUrl, Constants.IframeSelections.Killchain);
                    } else if (status.sha !== undefined && status.sha !== null
                        && status.sha !== 'None' && status.sha !== '') {
                        this.saveLog(this, this.title, 'Open Kill Chain Report. (Sha1: ' + status.sha,
                            this.getDurationInSeconds(this.log_start, Date.now()), null);
                        let openUrl = this.getPlatformKillChainEndPoint + "/" + status.sha + "/summary";
                        this.openUrlInIframe(openUrl, Constants.IframeSelections.Killchain);
                    }
                }
            }
            ,
            getKnowledgeBaseUrl(data) {
                return data.knowledge_base_url;
            }
            ,
            showOrHideKnowledgeBasedQuestionMark(data) {
                return data.knowledge_base_url && data.knowledge_base_url !== 'None';
            }
            ,
            showOrHideKillChain(data) {
                var response = false;
                for (let i = 0; i < this.cols.length; i++) {
                    if (data.sha1 !== undefined && data.sha1 !== null
                        && data.sha1 !== 'None' && data.sha1 !== '') {
                        response = true;
                    } else if (data.sha !== undefined && data.sha !== null
                        && data.sha !== 'None' && data.sha !== '') {
                        response = true;
                    }
                }
                return response;
            }
            ,
            showEmail(data) {
                return !((data.mail_content == null || data.mail_content === '' || data.mail_content === 'None')
                    && (data.eml_origin == null || data.eml_origin === '' || data.eml_origin === 'None'));
            }
            ,
            createTooltips() {
                var self = this;
                $(".vi-datatable tbody .cell-tooltip").hover(
                    // Mouse enter
                    function (e) {
                        var rect = e.target.getBoundingClientRect();
                        var text = $(e.target).html();
                        self.$refs.globalTooltip.showTooltip(rect.top + 25, rect.left, text);
                    },
                    // Mouse leave
                    function () {
                        self.$refs.globalTooltip.hideTooltip();
                    }
                )
            }
            ,
            canNotified(row) {
                if (row.notify_type.value == STOLEN_PASS_CHANGED ||
                    (row.account_email == undefined || row.account_email == null || row.account_email.trim() == '')) {
                    return true;
                } else {
                    return false;
                }
            }
            ,
            onStolenCheckBoxClicked(row) {
                this.$emit("onStolenCheckBoxClicked", row);
            }
            ,
            selectAll(checked) {
                var idList = [];
                for (var i = 0; i < this.tableData.length; i++) {
                    if (this.tableData[i].notify_type.value != STOLEN_PASS_CHANGED &&
                        (this.tableData[i].account_email != undefined && this.tableData[i].account_email != null
                            && this.tableData[i].account_email.trim() != '')) {
                        this.tableData[i].checked = checked;
                        idList.push(this.tableData[i].matched_credential_id);
                    }
                }
                this.$emit("onStolenSelectAllClicked", checked, idList);
            }
            ,
            sendMail() {
                this.$emit("onStolenSendMailClicked");
            }
            ,
            getSummary() {
                if (this.isDataTableVisible) {
                    this.summarySelectedState = null;
                }
                if (this.isSummaryVisible) {
                    if (this.summaryRequestParams.is_partner) {
                        this.summaryRequestParams.enterprise_id = this.getSelectedPartner;
                    } else {
                        this.summaryRequestParams.enterprise_id = this.getEnterpriseId;
                    }
                } else {
                    return;
                }
                let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/threat_summary/get', this.summaryRequestParams);
                promise.then(response => {
                    this.summaryStatistics = response.body.data;
                    this.isSummaryFetched = true;
                }, response => {
                    this.summaryStatistics = null;
                })
            }
        },
        watch: {
            globalDate: function () {
                if (this.globalDate) {
                    /**
                     * search has made from date picker
                     * @type {*|string}
                     */
                    let year = this.globalDate.substring(0, 4);
                    let month = this.globalDate.substring(5, 7);
                    let dt = this.globalDate.substring(8, 10);
                    this.filteredDate = year + '.' + month + '.' + dt;
                    this.summarySelectedState = null;
                    this.globalDate = null;
                    this.refreshServerSidePage();
                }
            }
        },
        beforeMount() {
            this.getSummary();
            this.getPartnerList();
        },
        mounted() {
            if (this.clientPagination) {
                this.getDataForClientPagination();
            }
            var self = this;
            if (this.hasTooltipColumn) {
                EventBus.$on('tooltipClicked', self.onTooltipClick);
            }
        },
        beforeDestroy() {
            EventBus.$off('tooltipClicked', this.onTooltipClick);
        }
    }
</script>

<style>
    #paginationInfoText {
        position: absolute;
        top: 0;
        left: 0;
        text-align: left;
        margin-top: 10px;
        font-size: 12px;
        color: white;
        font-family: 'Digital-Serial-Regular';
        max-width: 20%;
        -webkit-transition: opacity .15s ease-in-out;
        -moz-transition: opacity .15s ease-in-out;
        -ms-transition: opacity .15s ease-in-out;
        -o-transition: opacity .15s ease-in-out;
        transition: opacity .15s ease-in-out;
    }

    .VuePagination__count {
        display: none;
    }

    #paginationDiv {
        display: flex;
        align-self: flex-end;
        justify-content: flex-end;
        align-items: center;
    }

    .VueTables__pagination-wrapper label {
        display: none;
    }

    .VuePagination ul {
        display: none;
    }

    @-moz-document url-prefix() {
        .VueTables__pagination-wrapper {
            position: absolute;
            right: 1vw;
            bottom: -650px;
        }
    }

    .VueTables__pagination-wrapper {
        position: absolute;
        right: 1vw;
        bottom: -64vh;
    }

    .VueTables__pagination-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .VuePagination img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }

    .VueTables__pagination-wrapper::-webkit-scrollbar {
        display: none !important;
    }

    .VueTables__pagination-wrapper select {
        margin-right: 8px;
        background: black;
        color: white;
    }

    .VuePagination #paginationTotalPage {
        color: white;
        text-align: center;
        background: #1A1E23;
        width: 70px;
        height: 34px;
        font-size: 16px;
        margin: 0 8px 0 0;
        padding-top: 7px;
        border-radius: 4px;
    }

    .VuePagination #paginatorInput {
        width: 70px;
        height: 34px;
        margin-right: 8px;
        border-radius: 4px;
        border: 0;
        font-size: 16px;
        text-align: center;
        background: white;
        color: black;
    }

    @-moz-document url-prefix() {
        .VuePagination.row {
            padding-top: 0 !important;
        }
    }

    .VuePagination #paginationSlash {
        color: white;
        font-size: 16px;
        margin: 0 8px 0 0;
    }

    #topDiv {
        display: flex;
    }

    #topDivEye {
        display: flex;
        justify-content: space-between;
    }

    .loading-modal-container {
        height: calc(100%);
        width: calc(100%);
        z-index: 10;
    }

    .VueTables__sortable {
        cursor: pointer;
    }

    .send-mail-button {
        position: absolute !important;
        right: 300px !important;
    }

    .url-count {
        text-align: center;
        cursor: pointer;
    }

    .ss-thumbnail-container {
        width: 100%;
        height: 20px;
        padding: 0;
        margin: 0;
        position: relative;
    }

    .ss-thumbnail {
        width: 24px;
        cursor: pointer;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
    }

    .datatable-container {
        width: 100%;
        height: 100%;
        max-height: 100%;
        position: relative;
    }

    .title {
        display: inline-block;
        color: white;
        width: 50%;
        top: 5%;
        left: 25%;
        position: absolute !important;
        text-align: center;
        font-size: 20px;
        font-family: 'Digital-Serial-Bold';
    }

    .knowledge_base_question {
        text-align: right;
    }

    .details {
        cursor: pointer;
        width: 100%;
        height: 24px;
    }

    .download {
        cursor: pointer;
        width: 100%;
        height: 24px;
    }

    .button-container {
        width: 100%;
        height: 30px;
        position: relative;
    }

    .select_box_resolution_status {
        background-color: #1e2b34;
        color: white;
        border: black solid 1px;
        border-radius: 4px;
        height: 30px;
        width: 100%;
    }

    .select_box_resolution_status option {
        color: white !important;
    }

    .delete-button {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background-color: rgba(255, 0, 67, 1);
        font-family: 'Digital-Serial-Bold';
        border: none;
        color: white;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        width: 100px;
        font-weight: bold;
    }

    .editButton {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background-color: rgb(117, 32, 250);
        font-family: 'Digital-Serial-Bold';
        border: none;
        color: white;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        width: 100px;
        font-weight: bold;
    }

    .eye-container {
        position: relative;
        width: 100%;
        height: 16px;
    }

    .eye-text {
        position: absolute;
        top: 4px;
        bottom: 0;
        left: 5%;
        width: calc(100% - 45px);
        overflow: hidden;
        margin-bottom: 0;
    }

    .sha-text {
        position: absolute;
        top: 4px;
        bottom: 0;
        left: 10%;
        width: 100%;
        overflow: hidden;
        margin-bottom: 0;
    }

    .sha-one-text {
        position: absolute;
        top: 4px;
        bottom: 0;
        left: 10%;
        width: 100%;
        overflow: hidden;
        margin-bottom: 0;
    }

    .column-text {
        position: absolute;
        top: 4px;
        bottom: 0;
        left: 10%;
        width: 100%;
        overflow: hidden;
        margin-bottom: 0;
    }

    .eye-text-open {
        top: 0;
    }

    .eye-img {
        position: absolute;
        top: -4px;
        bottom: 0;
        right: 5%;
    }

    .global-eye {
        position: absolute;
        top: -2px;
        right: 5%;
    }

    .email {
        cursor: pointer;
        width: 100%;
        height: 24px;
    }

    .action-button {
        font-family: 'Digital-Serial-Bold';
        background-color: rgb(117, 32, 250);
        border: none;
        color: white;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        width: 100px;
        font-weight: bold;
        position: absolute;
        right: 150px;
        top: 0;
    }

    .action-button-big {
        width: 140px;
    }

    .settings-datatable .export-csv-button {
        font-family: 'Digital-Serial-Bold';
        background-color: rgb(117, 32, 250);
        border: none;
        color: white;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        font-weight: bold;
        position: fixed !important;
        right: 300px;
        top: 146px;
        width: 140px;
    }

    .save_changes_button {
        font-family: 'Digital-Serial-Bold';
        background-color: rgb(117, 32, 250);
        border: none;
        color: white;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        font-weight: bold;
        left: 19.5%;
        width: 140px;
    }

    .pages .export-csv-button {
        font-family: 'Digital-Serial-Bold';
        background-color: rgb(117, 32, 250);
        border: none;
        color: white;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        font-weight: bold;
        top: 0;
        position: absolute !important;
        right: 150px !important;
        width: 140px;
    }

    .secondary-action-button-big {
        font-family: 'Digital-Serial-Bold';
        background-color: rgb(117, 32, 250);
        border: none;
        color: white;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        width: 140px;
        font-weight: bold;
        position: absolute;
        right: 300px;
        top: 0;
    }

    .disabled-export {
        background-color: grey;
    }

    .circle {
        margin-left: 15px;
        width: 20px;
        height: 20px;
        /*-webkit-border-radius: 10px;*/
        /*-moz-border-radius: 10px;*/
        /*border-radius: 10px;*/
        text-align: center;
    }

    .current_status_color {
        width: 20px;
        height: 20px;
        text-align: center;
        margin-left: 40%;
    }

    .current_status_date {
        text-align: center;
        font-size: 14px;
        padding-top: 1px;
        padding-right: 5px;
    }

    .kill-chain-button {
        /*padding-left: 2px;*/
    }

    .kill-chain-button-clicks {
        cursor: pointer !important;
        opacity: 1 !important;
    }

    .kill-chain-button-clicks-no-report {
        color: currentColor;
        cursor: not-allowed !important;
        opacity: 0.5;
        pointer-events: none;
        text-decoration: none;
    }

    .kill-chain-button-clicks-no-report:hover {

    }

    #server-table .table-responsive {
        height: 58vh !important;
        overflow-y: hidden;
    }

    #client-table .table-responsive {
        height: 65vh !important;
        overflow-y: hidden;
    }

    #client-table {
        padding: 0 20px 0 20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/datatable/DataTable.vue